import { render } from "./MultiDropdown.vue?vue&type=template&id=3e15f9d8&scoped=true"
import script from "./MultiDropdown.vue?vue&type=script&lang=ts"
export * from "./MultiDropdown.vue?vue&type=script&lang=ts"

import "./MultiDropdown.vue?vue&type=style&index=0&id=3e15f9d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e15f9d8"

export default script